<template>
  <div class="layout_menu">
    <Header/>
    <div id="router-view-frame">
      <router-view/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/elements/lp/Header.vue'
import Footer from '@/elements/lp/Footer.vue'

export default {
  components: {
    Footer, Header
  }
}
</script>
